<template>
  <main class="main">
    <h4 class="ml-3">{{ $t("lang.label.attendance_stats") }}</h4>
    <section>
    <div
      class="mx-2"
      v-if="['1', '9'].includes(currentUser.role_id) || isBdrUser()"
    >
      <div class="col-md-12 px-0">
        <div
          class="container-fluid w-100 mb-5 p-3 border bg-white rounded stats-wrapper"
        >
          <div class="d-flex flex-wrap">
            <div class="w-25 input-group input-group-sm p-1">
              <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-sm"
                  >Date</span
                >
              </div>
              <date-picker
                id="startDatePicker"
                class="form-control"
                v-model="filterMonth"
                :config="datePickerConfig"
                placeholder="Start Date"
              ></date-picker>
            </div>

            <!-- <div class="w-25 input-group input-group-sm p-1 treeselect-wrapper" v-if="!isBdrUser()">
              <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-sm"
                  >BDR</span
                >
              </div>
              <treeselect
                v-model="bdr_user_id"
                :options="bdr_users"
                :multiple="false"
                :clearable="false"
                :normalizer="normalizeOptions"
                class="form-control inline-table"
                @change="loadAttendanceStats"
              >
              </treeselect>
            </div> -->

            <button
            class="btn btn-success w-25 ml-5"
            @click="loadAttendanceStats()"
            style="width: 100%"
            :disabled="loading"
          >
            <i class="icon-calendar-check-o mr-2"></i>
            <small>
              {{ $t("lang.button.filter") }}
            </small>
          </button>
          </div>
        </div>
      </div>
    </div>

    <LoadingSpinner v-if="loading" />

    <div class="row" v-else>
      <div class="col-sm-12 mt-5">
        <div class="table-responsive">
          <div v-for="(parent, key) in parents" :key="parent + key">
            <div class="pb-4 max-content table-sticky-1col">
              <h3 class="ml-3">{{ parent.parent_name }}</h3>
              <div class="table-sticky-1col">
                <StatsTable
                  :statsClient="statsClient[parent.parent_name]"
                  :statsType="getStatsTypeByParent(parent.parent_name)"
                  :statsDate="statsDate"
                  :showTotal="
                    parent.parent_name == 'Percentages' ? false : true
                  "
                  :onlyTotal="false"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </section>
  </main>
</template>
<script>
import { opportunitiesService, usersService } from "@/_services";
import StatsTable from "@/components/Usages/StatsTable.vue";
import { mapState, mapActions } from "vuex";
import moment from "moment";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  name: 'AttendanceStats',
  props: {
    type: String,
    targetId: {
      type: String,
      default: "0",
    },
  },
  components: {
    StatsTable,
    LoadingSpinner,
    Treeselect,
  },
  data() {
    return {
      loading: true,
      statsClient: {},
      statsDate: [],
      parents: [],
      statsType: [],
      selectUserBdr: false,
      bdr_user_id: null,
      bdr_users: null,
      datePickerConfig: {
        format: "YYYY-MMM",
        viewMode: "months",
        minDate: moment().subtract(12, "month"),
        maxDate: moment().endOf("day"),
      },
      filterMonth: moment().format("YYYY-MMM"),
    };
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.authentication.user,
    }),
  },
  created() {
    //this.getUserBdr();
    this.loadAttendanceStats();
  },
  mounted() {
    this.udpdateHeader('attendance_stats');
  },
  methods: {
    ...mapActions("headertopbar", {
         setCurrentRoute:"setRoute",
         setCurrentRouteChild:"setRouteChild"
    }),
    udpdateHeader(route) {
      this.setCurrentRoute({ page: route });
      this.setCurrentRouteChild({ child: "" });
    },  
    isBdrUser() {
      return (
        this.currentUser.team_role_id == 2 && this.currentUser.role_id == 2
      );
    },
    mergeObjects(statsX, statsX2) {
      statsX2.forEach((item2) => {
        let item = statsX.find((item) => item.fdate == item2.fdate);
        if (item) {
          Object.assign(item, item2);
        } else {
          statsX.push(item2);
        }
      });
      return statsX;
    },
    loadAttendanceStats() {
      this.loading = true;
      this.statsClient = {};
      this.statsDate = [];
      this.parents = [];
      this.statsType = [];

      const userBdr = this.isBdrUser() ? this.currentUser.id : this.bdr_user_id;

      opportunitiesService
        .getAttendaceStattistics({
          bdr_user_id: userBdr,
          month: this.filterMonth,
          type: this.type,
          target_id: this.targetId,
        })
        .then((res) => {
          // La respuesta es un array directo
          if (res && Array.isArray(res) && res.length > 0) {
            // Calcular totales por día para los porcentajes
            let totalsByDate = {};
            res.forEach((item) => {
              const fdate = item.fdate;
              if (!totalsByDate[fdate]) {
                totalsByDate[fdate] = 0;
              }
              totalsByDate[fdate] += parseInt(item.total_status || 0, 10);
            });

            // Agregar porcentajes a los datos originales
            let resWithPercentages = res.map((item) => {
              const total = totalsByDate[item.fdate] || 0;
              const percentage = total > 0 
                ? (Number((item.total_status || 0) / total) * 100).toFixed(2)
                : 0;
              return {
                ...item,
                total_status_percentage: percentage
              };
            });

            let statsX = this.formatData(
              resWithPercentages,
              "total_status",
              "Statuses",
              "qty"
            );

            let attendanceStatsPer = []
            let processedDates = new Set();

            res.forEach((item) => {
              const dateKey = `${item.fdate}_${item.name}`;
              
              // Evitar procesar el mismo item múltiples veces
              if (processedDates.has(dateKey)) {
                return;
              }
              processedDates.add(dateKey);

              //filtro x dia y sumo los valores para obtener el total
              const total = totalsByDate[item.fdate] || 0;

              if (total > 0) {
                const data = 
                {
                  fdate: item.fdate,
                  total_status_per: (Number((item.total_status || 0) / total) * 100).toFixed(2),
                  name: item.name
                }
                attendanceStatsPer.push(data);
              }
            })

            // if (attendanceStatsPer.length > 0) {
            //   let statsX1 = this.formatData(
            //     attendanceStatsPer,
            //     "total_status_per",
            //     "Percentages",
            //     "rate"
            //   );          

            //   statsX = this.mergeObjects(statsX, statsX1);
            // }

            statsX.forEach((item) => {
              const client_id = 0; // No hay client_id en la respuesta
              const client_name = ""; // No hay client_name en la respuesta
              const fdate = item.fdate;

              if (!this.statsDate.find((field) => field.date == fdate)) {
                this.statsDate.push({ date: fdate });
              }

              this.statsType.forEach((statType) => {
                let type = statType.id + "_" + statType.format;
                let parent = statType.parent;

                if (
                  !this.parents.find((field) => field.parent_name == parent)
                ) {
                  this.parents.push({ parent_name: parent });
                }

                if (this.statsClient[parent] == undefined) {
                  this.statsClient[parent] = {};
                }
                if (this.statsClient[parent][client_id] == undefined) {
                  this.statsClient[parent][client_id] = {};
                  this.statsClient[parent][client_id]["name"] = client_name;
                }
                if (this.statsClient[parent][client_id][fdate] == undefined) {
                  this.statsClient[parent][client_id][fdate] = item;
                }

                if (item[type] !== undefined && item[type] !== null) {
                  if (this.statsClient[parent][client_id][type] === undefined) {
                    this.statsClient[parent][client_id][type] = 0;
                    this.statsClient[parent][client_id][type + "_total"] = 0;
                  }
                  this.statsClient[parent][client_id][type] += parseFloat(
                    item[type]
                  );
                  this.statsClient[parent][client_id][type + "_total"]++;
                }

                // Guardar el porcentaje para la tabla Statuses (excepto Total)
                // StatsTable usa stats[date.date][statType.id] cuando showQty es true
                if (parent === "Statuses" && statType.label !== "Total") {
                  const percentageKey = statType.id; // El id completo del statType (ej: "Confirmed attendance_Statuses")
                  // El porcentaje ya está guardado en item con la clave percentageKey + "_percentage"
                  // pero StatsTable busca stats[date.date][statType.id], así que lo guardamos ahí
                  if (item[percentageKey + "_percentage"] !== undefined) {
                    // Guardar el porcentaje formateado con el símbolo % en el campo que StatsTable lee cuando showQty es true
                    if (this.statsClient[parent][client_id][fdate][percentageKey] === undefined) {
                      const percentageValue = parseFloat(item[percentageKey + "_percentage"] || 0);
                      this.statsClient[parent][client_id][fdate][percentageKey] = percentageValue.toFixed(2) + " %";
                    }
                  }
                }
              });
            });

            this.statsDate.sort((a, b) => a.date - b.date);

            this.statsType.forEach((statType) => {
              let type = statType.id + "_" + statType.format;
              let parent = statType.parent;

              if (["avg", "percentage", "rate"].includes(statType.format)) {
                if (this.statsClient[parent] && this.statsClient[parent][0] && this.statsClient[parent][0][type + "_total"] > 0) {
                  this.statsClient[parent][0][type] =
                    this.statsClient[parent][0][type] /
                    this.statsClient[parent][0][type + "_total"];
                }
              }
            });
          }

          this.loading = false;
        })
        .catch((err) => {
          console.error("Error loading attendance stats:", err);
          this.loading = false;
        });
    },
    getUserBdr() {
      usersService
        .getBdrs()
        .then((res) => {
          this.bdr_users = res.result;
        })
        .catch((err) => console.error(err));
    },
    normalizeOptions(node) {
      return {
        id: node.id,
        label: node.name,
      };
    },
    formatData(x, field_value, parent, format_type) {
      let statsX = [];
      let total = 0;
      let total1 = 0;
      let total2 = 0;
      x.forEach((item) => {
        const fdate = item.fdate;
        if (!statsX.find((field) => field.fdate == fdate)) {
          statsX.push({ fdate: fdate });
        }
        let statWeek = statsX.find((field) => field.fdate == fdate);
        let label = item.name;
        let key = label + "_" + parent;

        let value = 0;
        if (Array.isArray(field_value)) {
          if (item[field_value[1]] > 0) {
            let val0 = parseInt(item[field_value[0]]);
            let val1 = parseInt(item[field_value[1]]);
            total1 += val0;
            total2 += val1;
            total = total1 / total2;
            value = val0 / val1;
            if (["percentage", "rate"].includes(format_type)) {
              value = value * 100;
            }
          }
        } else {
          value = item[field_value] || 0;
        }

        statWeek[key + "_" + format_type] = value;
        
        // Guardar el porcentaje si existe en el item
        if (item.total_status_percentage !== undefined && parent === "Statuses") {
          statWeek[key + "_percentage"] = parseFloat(item.total_status_percentage);
        }

        if (Array.isArray(field_value)) {
          statWeek["Total_" + parent + "_" + format_type] = total * 100;

          if (!this.statsType.find((field) => field.id == "Total_" + parent)) {
            this.statsType.push({
              id: "Total_" + parent,
              label: "Total",
              format: format_type,
              showQty: false,
              showTotal: true,
              parent: parent,
              className: "font-weight-bold",
            });
          }
        }

        if (!this.statsType.find((field) => field.id == key)) {
          this.statsType.push({
            id: key,
            label: label,
            format: format_type,
            showQty: parent === "Statuses" && label !== "Total", // Mostrar porcentaje en Statuses excepto Total
            showTotal: true,
            parent: parent,
          });
        }
      });
      return statsX;
    },

    getStatsTypeByParent(parent) {
      let x = this.statsType.filter((e) => e.parent === parent);
      const customOrder = [
        "Confirmed attendance",
        "Unable to reach",
        "Cancelled meeting",
        "Rescheduled meeting",
        "Total",
      ];

      const entries = Object.entries(x);

      entries.sort(([keyA, valueA], [keyB, valueB]) => {
        const indexA = customOrder.indexOf(valueA.label);
        const indexB = customOrder.indexOf(valueB.label);
        return (
          (indexA === -1 ? Infinity : indexA) -
          (indexB === -1 ? Infinity : indexB)
        );
      });

      return entries.map(([, value]) => value);
    },
    getRate(a, b) {
      if (b == 0) {
        return 0;
      } else {
        return (parseFloat(a) / parseFloat(b)) * 100;
      }
    },
  },
};
</script>

<style scoped>
</style>